// Imports
import React from 'react';
import SidebarLink from './shareables/foundation/admin-ui/components/sidebar/link';
import { faCircleDollar, faClockRotateLeft, faTableList } from '@fortawesome/pro-light-svg-icons';


// Function component
const SidebarLinks: React.FC = () => (
	<React.Fragment>
		<SidebarLink to='/websites' icon={faTableList} text='Websites' />
		<SidebarLink to='/billing' icon={faCircleDollar} text='Billing' />
		<SidebarLink to='/activity-log' icon={faClockRotateLeft} text='Activity log' />
	</React.Fragment>
);

export default SidebarLinks;
